import {
    SAVINGS_PLAN_SUBSCRIPTION_UPDATE_COTIZACION_BEGIN,
    SAVINGS_PLAN_SUBSCRIPTION_UPDATE_COTIZACION_SUCCESS,
    SAVINGS_PLAN_SUBSCRIPTION_UPDATE_COTIZACION_FAILURE,
    SAVINGS_PLAN_SUBSCRIPTION_UPDATE_COTIZACION_DISMISS_ERROR
} from '../constants'
import axios from 'axios'
import { REACT_APP_COTIZADOR_API } from '../../../../common/config'

const MULTIPLICADOR_COTIZACION = 1

export function updateCotizacion(quoteToEdit, params, selectedId) {
    const {
        year,
        yearId,
        kilometraje,
        brand,
        brandId,
        model,
        modelId,
        version,
        versionId
    } = params
    return dispatch => {
        // optionally you can have getState as the second argument
        dispatch({
            type: SAVINGS_PLAN_SUBSCRIPTION_UPDATE_COTIZACION_BEGIN,
            data: params
        })

        return new Promise((resolve, reject) => {
            // Armo el body para la consulta de la cotización a actualizar
            const body_cotizador = {
                costs: [
                    {
                        type: 'general',
                        amount: 0
                    },
                    {
                        type: 'cubiertas',
                        amount: 0
                    }
                ],
                interior: 5, // 10: excelente, 5: bueno, 0: malo
                kms: kilometraje,
                vehicle: {
                    brand: brandId,
                    brandName: brand,
                    model: modelId,
                    modelName: model,
                    version: versionId,
                    versionName: version,
                    year: year,
                    yearId: yearId
                }
            }
            const doRequest = axios.post(
                REACT_APP_COTIZADOR_API + '/cotizador/v1/quotes',
                body_cotizador
            )
            doRequest.then(
                res => {
                    dispatch({
                        type: SAVINGS_PLAN_SUBSCRIPTION_UPDATE_COTIZACION_SUCCESS,
                        data: res.data,
                        params: params,
                        quoteEdited: quoteToEdit,
                        selectedId: selectedId
                    })
                    resolve(res)
                },
                () => {
                    dispatch({
                        type: SAVINGS_PLAN_SUBSCRIPTION_UPDATE_COTIZACION_FAILURE,
                        data: {
                            error: 'El vehículo no se encuentra segmentado',
                            ...params
                        }
                    })
                    reject({
                        message: 'El vehículo no se encuentra segmentado'
                    })
                }
            )
        })
    }
}

// Async action saves request error by default, this method is used to dismiss the error info.
// If you don't want errors to be saved in Redux store, just ignore this method.
export function dismissGetCotizacionError() {
    return {
        type: SAVINGS_PLAN_SUBSCRIPTION_UPDATE_COTIZACION_DISMISS_ERROR
    }
}

export function reducer(state, action) {
    switch (action.type) {
        case SAVINGS_PLAN_SUBSCRIPTION_UPDATE_COTIZACION_BEGIN:
            // Just after a request is sent

            return {
                ...state
            }

        case SAVINGS_PLAN_SUBSCRIPTION_UPDATE_COTIZACION_SUCCESS: {
            // The request is success
            const estimatedPrice = action?.data?.quote?.prices.find(
                price => price?.type === 'estimated'
            )
            const newQuotationId = action.data.id

            const quoteUpdated = { quote_id: newQuotationId }
            const cotizacionUpdated = {
                final_take_price:
                    estimatedPrice.amount * MULTIPLICADOR_COTIZACION,
                original_price:
                    estimatedPrice.amount * MULTIPLICADOR_COTIZACION,
                ...action.params,
                quotation_id: newQuotationId,
                km: action?.params?.kilometraje,
                valid: true,
                pending: false,
                error: null
            }
            //lugar en el array del elemento a modificar
            const indexQuote = state.quotes.findIndex(
                item => item.quote_id === action.selectedId
            )
            const indexEdit = state?.entregaUsados?.findIndex(
                item => item?.quotation_id === action?.selectedId
            )

            // busco el elemento a editar en el array.
            // elimino el viejo registro y lo reemplazo por el unuevo
            state.quotes.splice(indexQuote, 1, quoteUpdated)
            state.entregaUsados.splice(indexEdit, 1, cotizacionUpdated)

            return {
                ...state,
                quotes: [...state.quotes],
                entregaUsados: [...state.entregaUsados],
                getCotizacionPending: false,
                getCotizacionError: null
            }
        }

        case SAVINGS_PLAN_SUBSCRIPTION_UPDATE_COTIZACION_FAILURE:
            // The request is failed
            return {
                ...state,
                getCotizacionPending: false,
                getCotizacionError: action.data.error,
                patenteCodeError: action.data.patenteCodeError
            }

        case SAVINGS_PLAN_SUBSCRIPTION_UPDATE_COTIZACION_DISMISS_ERROR:
            // Dismiss the request failure error
            return {
                ...state,
                getCotizacionPending: false,
                getCotizacionError: null
            }

        default:
            return state
    }
}
